
export default {
  name: 'BaseNavigatorStreamCard',
  props: {
    stream: {
      type: Object,
      default: null,
    },
    experts: {
      type: Array,
      default: () => [],
    },
    countAllExperts: {
      type: Number,
      default: 0,
    },
    countComingEvents: {
      type: Number,
      default: 0,
    },
    countComingOffers: {
      type: Number,
      default: 0,
    },
    countVideos: {
      type: Number,
      default: 0,
    },
    theme: {
      type: String,
      default: 'light',
    },
  },
  data() {
    return {
      expertsVisibleCount: 6,
    }
  },
  computed: {
    isHavButtons() {
      return (
        (this.stream?.actionButton && this.stream?.actionButton?.status) ||
        this.stream.statistics?.articles?.publishedCount +
          this.stream.statistics?.telegram?.publishedCount >
          0 ||
        this.stream?.statistics?.events?.publishedCount > 0 ||
        this.experts?.length > 0
      )
    },
    popularExperts() {
      return this.experts?.slice(0, this.expertsVisibleCount)
    },
    auditorium() {
      if (this.stream.statistics?.articles?.viewsCount < 100) {
        return 'менее 100'
      } else {
        return this.stream.statistics?.articles?.viewsCount
      }
    },
    materials() {
      return (
        this.stream.statistics?.articles?.publishedCount +
        this.stream.statistics?.telegram?.publishedCount
      )
    },
  },
}
